<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import { getTeamsByTeamIds } from '@/api/FirebaseTeamWrapper.js'
import { addTree } from '@/api/FirebaseTreesWrapper.js'
import { countCharacters, hasAdminRole } from '@/api/Utilities.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
const analytics = getAnalytics(firebaseApp)

require('../../css/style.css')

var makeQnq = {
  components: {
    modalWindow
  },
  data () {
    return {
      tree: {},
      makeMsg: '',
      svgMsg: [],
      makeMsgLength: 0,
      alertMsg: '',
      userId: '',
      userData: undefined,
      isAnonymousModal: false,
      selectedTeam: '', // Treeのチーム scope に代入される
      teams: [], // ユーザの所属するチーム一覧の初期値 {id: "string", name: "string"}
      isCreated: false,
      title: constant.DEFAULT_DOMAIN_TITLE,
      issueLimit: constant.DEFAULT_ISSUE_LIMIT
    }
  },
  async created () {
    this.userId = await getMyUserId()
    this.userData = await getMyUserData()
    this.isAnonymous = this.userData.isAnonymous
    const teams = await getTeamsByTeamIds(this.userData.teams)
    for (const team of teams) {
      this.teams.push({id: team.id, name: team.teamName})
    }

    document.title = 'Make | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'Make | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'makeqnq/Makepqnq')
    }
    this.isCreated = true
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  mounted () {
  },
  watch: {
    makeMsg: function (val) {
      this.makeMsgLength = countCharacters(this.makeMsg)
      this.svgTxtArray(this.makeMsg)
    }
  },
  methods: {
    regEscape: function (message) {
      if (!message) { return }
      let match = message.match('https?://[^\\s|^<]+')
      if (match) {
        message = message.replace(match[0], '')
      }
      return message
    },
    svgTxtArray (message) {
      this.svgMsg = []
      if (!message) { return }
      let msg = this.regEscape(message)
      let tmp = ''
      let count = 0
      const maxLength = 18

      for (let word of msg.split(/\n/)) {
        // 20文字以上だと無理やり改行, 45文字までなので 2loop
        for (let i = 2; i >= 0; i--) {
          if (word.length > maxLength * i) {
            word = word.slice(0, maxLength * i) + '\n' + word.slice(maxLength * i)
          }
        }
        // 改行のみは+=されないので、wordが空なら改行コード追加
        if (!word) { word = '\n' }
        tmp += word
      }

      for (const word of tmp.split(/\n/)) {
        this.svgMsg[count] = word
        count++
      }
      // なぜか先頭に空白が入るのでよくないけど配列先頭削除
      this.svgMsg.shift()
    },
    async postTree () {
      // console.log('postTree')
      if (this.isAnonymous) {
        this.isAnonymousModal = true
        return
      }
      this.alertMsg = ''
      const makeMsg = this.makeMsg
      if (!makeMsg) {
        this.alertMsg = '文字を入力してください'
        return
      }
      const msg = this.regEscape(makeMsg)
      // console.log('length: ' + msg.length)
      if (msg.length > this.issueLimit) {
        this.alertMsg = this.issueLimit + '文字を超えてます'
        return
      }
      try {
        const treeRef = await addTree(makeMsg, 50, this.selectedTeam)
        // =================== GOOGLE ANALYTICS ===================
        logEvent(analytics, 'select_content', {
          items: 'post_issue',
          promotions: this.userId,
          content_type: 'issue',
          content_id: treeRef.id
        })
        Router.push('tree/' + treeRef.id)
        return treeRef
      } catch (err) {
        this.alertMsg = 'failed!'
        console.error(err)
      }
    },
    closeAnonymousModal () {
      this.isAnonymousModal = false
    }
  }
}

export default makeQnq
</script>
<style scoped>
.makeqnq {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.control{
  margin: auto;
}
.make-label{
  background-color: #f0f8ff;
}
.progress{
  margin-top: 10px;
}
.q-bar .columns .column .progress{
  margin-top: 2px;
}
.svg {
    width: 100%;
}
.svg-wrapper {
    position: relative;
    width: 100%;
    padding-top: 60%; /* SVG高さ / SVG幅 * 100 */
}
.svg-wrapper svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
<template>
<div class='makeqnq' v-if="isCreated">
  <div class="make-label">
    <label class="label">ツリーの作成</label>
  </div>
  <br>
  <p>いま考えてることを書いてみよう</p>
  <div class="field">
    <div class="control">
      <textarea v-if="makeMsgLength<=issueLimit" class="textarea" placeholder="いま何かんがえてる？" v-model="makeMsg"></textarea>
      <textarea v-else class="textarea is-danger" placeholder="文字OVER" v-model="makeMsg"></textarea>
    </div>
  </div>
  <div class="q-bar">
    <div class="columns is-mobile is-marginless">
      <div class="column is-three-quarters">
        <div class="add-paddingleft">
          <progress class="progress is-gray is-small" :value="makeMsgLength" :max="issueLimit"></progress>
        </div>
      </div>
      <div class="column is-size-7">残り{{issueLimit-makeMsgLength}}</div>
    </div>
  </div>
  <br>

  <!-- チームの選択 -->
  <div class="select">
    <select v-model="selectedTeam">
      <option disabled value="">チームの選択</option>
      <option v-for="team in teams"
        v-bind:value="team.id"
        v-bind:key="team.id">
      {{ team.name }}
      </option>
    </select>
  </div>
  <hr>

  <div v-if="makeMsg !=='' && makeMsgLength <= issueLimit ">
    <a class="button is-link is-focuse has-text-weight-bold" @click.once="postTree();">
      <span class="icon">
        <i class="fa-solid fa-paperclip"></i>
      </span>
      <span>POSTする</span>
    </a>
  </div>
  <div v-else>
    <a class="button has-text-weight-bold" @click="postTree();">
      <span class="icon">
        <i class="fa-solid fa-paperclip"></i>
      </span>
      <span>POSTする</span>
    </a>
  </div>
  <br>
  <p class="help is-danger">{{alertMsg}}</p>

  <div class="anonymous-modal-window">
    <modalWindow v-if="isAnonymousModal">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete" @click="closeAnonymousModal()"></button>
        </div>
      </template>
      <p>ログインするとポストできますよ！</p>
      <template slot="footer">
        <router-link class="buttons is-centered" @click.native="clickSetViewingPage()" to="/login">
          <button class="button is-link">Loginページへ</button>
        </router-link>
        <br>
      </template>
    </modalWindow>
  </div>
  <!--
  <pre>{{ $data }}</pre>
  -->
  <div class="svg" v-show="false">
    <div class="svg-wrapper">
      <svg ref="svgCard" width="909" height="478" viewBox="0 0 909 478" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="hidden"><defs><clipPath id="clip0"><path d="M173 137 1082 137 1082 615 173 615Z" fill-rule="evenodd" clip-rule="evenodd"/></clipPath><image width="256" height="104" xlink:href="data:image/jpeg;base64,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" preserveAspectRatio="none" id="img1"></image><clipPath id="clip2"><path d="M0 0 179.692 0 179.692 73 0 73Z" fill-rule="evenodd" clip-rule="evenodd"/></clipPath></defs><g clip-path="url(#clip0)" transform="translate(-173 -137)"><path d="M174 163.157C174 149.263 185.263 138 199.157 138L1055.84 138C1069.74 138 1081 149.263 1081 163.157L1081 588.843C1081 602.737 1069.74 614 1055.84 614L199.157 614C185.263 614 174 602.737 174 588.843Z" fill="#191970" fill-rule="evenodd"/><path d="M193 189.034C193 170.79 207.79 156 226.034 156L1026.97 156C1045.21 156 1060 170.79 1060 189.034L1060 505.966C1060 524.21 1045.21 539 1026.97 539L226.034 539C207.79 539 193 524.21 193 505.966Z" fill="#FFFFFF" fill-rule="evenodd"/><g clip-path="url(#clip2)" transform="matrix(1.00728 0 -0 1 190 541)"><use width="100%" height="100%" xlink:href="#img1" transform="scale(0.701923 0.701923)"></use></g></g>
        <text transform="translate(103.29 347.281)" fill="#000000" font-size="38" font-family="HiraginoSans-W5, Hiragino Sans" letter-spacing="-0.002em">
          <tspan v-for="(msg, index) in svgMsg" :key="index" x="10" :y="-180 + 60*index" >{{ msg }}</tspan>
        </text>
      </svg>
    </div>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/makeqnq/Makeqnq.vue